var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWeight = function SvgWeight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.763 9.327c.66 0 1.23.462 1.366 1.107l1.897 8.98a.96.96 0 0 1-.939 1.158H4.388a.96.96 0 0 1-.938-1.158l1.897-8.98a1.396 1.396 0 0 1 1.365-1.107h10.05zm-5.025-5.898a2.949 2.949 0 1 1 0 5.898 2.949 2.949 0 0 1 0-5.898z",
    vectorEffect: "non-scaling-stroke"
  })));
};
export { SvgWeight as ReactComponent };
export default __webpack_public_path__ + "2404d5d39d3bd9fc03ee7b5ba2f70a26.svg";